/**
 * Rewrite a redirectUri preserving original param order.
 * Handles nested query strings and fragments.
 *
 * @param {string} redirectUri - Fully encoded redirect URI
 * @param {string[]} preserveParams - Params to keep raw encoded
 * @returns {string} - New redirect URL
 */
export function rewriteRedirectUri(redirectUri, preserveParams = []) {
    try {
        const placeholder = '___PLUS___';
        const temp = redirectUri.replace(/%2B/g, placeholder);
        const decoded = decodeURIComponent(temp);
        const url = new URL(decoded);

        const encodedPairs = Array.from(url.searchParams.entries()).map(([key, value]) => {
            if (preserveParams.includes(key)) {
                const regex = new RegExp(`[?&]${key}=([^&]*)`);
                const match = redirectUri.match(regex);
                const rawValue = match ? match[1] : encodeURIComponent(value);
                return `${encodeURIComponent(key)}=${rawValue.replace(
                    new RegExp(placeholder, 'g'),
                    '%2B',
                )}`;
            }
            return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        });

        const base = `${url.origin}${url.pathname}`;
        const query = encodedPairs.length ? `?${encodedPairs.join('&')}` : '';
        const hash = url.hash || '';

        return `${base}${query}${hash}`;
    } catch {
        return redirectUri;
    }
}
